
import platformApi from "../../../axios";
export function requestProjectPage(params,data){
    return platformApi({
        url:'/platform-project/page',
        method:'post',
        data:data,
        params:params,
    })
}
export function requestProjectList(data){
    return platformApi({
        url:'/platform-project/list',
        method:'post',
        data:data,
    })
}
export function requestProjectDelete(ids){
    return platformApi({
        url:`/platform-project/${ids}`,
        method:'delete',
    })
}
export function requestProjectEditCustomerRemark(id,data){
    return platformApi({
        url:`/platform-project/edit/customer-remark/${id}`,
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'text/plain'
        }
    })
}
export function requestProjectEditRemark(id,data){
    return platformApi({
        url:`/platform-project/edit/remark/${id}`,
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'text/plain'
        }
    })
}
export function requestProjectEditPersonnel(data){
    return platformApi({
        url:`/platform-project/edit/personnel`,
        method:'put',
        data:data,
    })
}
export function requestProjectShareDelete(projectId,data){
    return platformApi({
        url:`/platform-project/share/remove/${projectId}`,
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
export function requestProjectShareAdd(projectId,data){
    return platformApi({
        url:`/platform-project/share/add/${projectId}`,
        method:'post',
        data:data
    })
}
export function requestProjectBs(data){
    return platformApi({
        url:`/delivery/transfer/contract/system/contract/properties`,
        method:'post',
        data:data,
    })
}
export function requestProjectSampleList(id){
    return platformApi({
        url:`/platform-project/sample-list/${id}`,
        method:'post',
    })
}

